import styled from 'styled-components';

export const Button = styled.button`
    font-family: 'Source Sans Pro';
    margin: 10px;
    white-space: nowrap;
    display: inline-block;
    line-height: 10px;
    padding: 0 14px;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    color: #fff;
    background: #6772e5;
    border-radius: 4px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.025em;
    text-decoration: none;
    -webkit-transition: all 0.15s ease;
    transition: all 0.15s ease;
    border: none;
    cursor: pointer;
    outline: none;
    &:hover {
        background-color: #7795f8;
        transform: translateY(-1px);
        box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);
    }
`;

export const TopText = styled.h3`
font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    margin: 15px 0 5px 0;
`
export const BottomText = styled.p`
font-weight: 300;
    color: #fff;
    margin: 5px 0 15px 0;
`


// WEBPACK FOOTER //
// ./src/ButtonComponent/styles.js